import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination, ParaSubtitle } from "../common";

const Settings = () => {
  return (
    <div>
      <PageTitle title='Settings' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='The circle on the top right corner tells you about pending notifications, the changes you can make to your profile settings and contact number of the admin' />
      <ParaImageDialog src='/tutorial_image/settings-1.png' />

      <ParaTitle paraTitle='Profile' />
      <Paragraph paragraph='Clicking on the profile will give your basic information that includes your name, email and contact number.' />
      <ParaImageDialog src='/tutorial_image/settings-2.png' />

      <ParaTitle paraTitle='Event Notifications' />
      <Paragraph paragraph='You can also check all the notification for your new events that are added to your account in the notification section.' />
      <ParaImageDialog src='/tutorial_image/settings-3.png' />
      
      <ParaTitle paraTitle='Settings' />
      <Paragraph paragraph='Clicking on the settings will give you the option to edit profile settings and change password.' />
      <ParaSubtitle paraSubtitle='Edit Settings' />
      <Paragraph paragraph='On clicking edit settings, you are redirected to the page to update your name, email and contact number.' />
      <ParaImageDialog src='/tutorial_image/settings-4.png' />
      <ParaImageDialog src='/tutorial_image/settings-5.png' />
      <ParaSubtitle paraSubtitle='Change Password' />
      <Paragraph paragraph='You can also change your password by clicking on the change Password tab. On clicking change password, you are redirected to the page to update your password.' />
      <ParaImageDialog src='/tutorial_image/settings-6.png' />
      <ParaImageDialog src='/tutorial_image/settings-7.png' />
      
      <ParaTitle paraTitle='Questions' />
      <Paragraph paragraph='On clicking the questions button, you can see the admin contact information where you can send your questions.' />
      <ParaImageDialog src='/tutorial_image/settings-8.png' />

      <Pagination
        pagination={{
          prev: { name: 'Password Reset', link: '/password-reset' }
        }}
      />
    </div>
  );
};

export default Settings;
